import React from "react";

const FilterBar = ({
  stateFilter,
  onStateChange,
  serviceTypeFilter,
  onServiceTypeChange,
}) => {
  return (
    <div className="flex gap-4 mb-4">
      <select
        className="filter"
        value={stateFilter}
        onChange={(e) => onStateChange(e.target.value)}
      >
        <option value="all">Tous les états</option>
        <option value="En développement">En développement</option>
        <option value="Déployé">Déployé</option>
      </select>
      <select
        className="filter"
        value={serviceTypeFilter}
        onChange={(e) => onServiceTypeChange(e.target.value)}
      >
        <option value="all">Tous les types</option>
        <option value="Développement Web">Développement Web</option>
        <option value="Développement Mobile">Développement Mobile</option>
      </select>
    </div>
  );
};

export default FilterBar;
